import { useContext } from 'react'

import { TwilioWorkerContext } from '../../providers'

export function useTwilioWorker() {
  const { worker } = useContext(TwilioWorkerContext)
  return { worker }
}
